<template>
  <div>
    <div v-if="stepName == 'Payment-3'">
      <keep-alive>
        <ach-form
          v-if="
            newPaymentMethodType === 'ach' || newPaymentMethodType === 'wire'
          "
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <canada-eft
          v-else-if="newPaymentMethodType === 'cad_eft'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <com-check
          v-else-if="newPaymentMethodType === 'comcheck'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <efs
          v-else-if="newPaymentMethodType === 'efs'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <e-check
          v-else-if="newPaymentMethodType === 'echeck'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <check-form
          v-else-if="newPaymentMethodType === 'check'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
        <clabe-form
          v-else-if="newPaymentMethodType === 'clabe'"
          :data="data"
          :first-time="firstTime"
          :step-name="stepName"
        />
      </keep-alive>
      <form-navigation-buttons
        v-if="!isNavigationDisabled"
        :enabled="!isNavigationDisabled"
        :component-identifier="componentIdentifier"
        :buttons-to-display="buttonsToDisplay"
        :is-button-disabled="isButtonDisabled"
        @next="handleNext"
        @back="handleBack"
      />
    </div>
  </div>
</template>
<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed, watch, ref } from 'vue';
import { useToast } from 'vue-toast-notification';
import stepInformation from '@/common/stepInformation';
import AchForm from './AchForm.vue';
import CheckForm from './CheckForm.vue';
import CanadaEft from './CanadaEft.vue';
import Comcheck from './Comcheck.vue';
import ECheck from './ECheck.vue';
import Efs from './Efs.vue';
import ClabeForm from './ClabeForm.vue';
import { formatErrorResponse } from '@/common/handleServerResponse';

export default {
  name: 'PaymentStepThree',
  components: {
    FormNavigationButtons,
    'ach-form': AchForm,
    'check-form': CheckForm,
    'canada-eft': CanadaEft,
    efs: Efs,
    'e-check': ECheck,
    'com-check': Comcheck,
    'clabe-form': ClabeForm,
  },
  props: {
    data: Object,
    updateField: Function,
    formPosition: Number,
    title: String,
    nextStep: Function,
    stepName: String,
    skipStep: Function,
  },
  // watch: {
  // formPosition: function (nv, ov) {
  //   if (nv < ov) {
  //     if(this.stepName === 'Payment-3'){
  //       this.$store.commit("toggleDisabledButton", { bool: false, source: 'PaymentStepThree #1' });
  //     }
  //   }
  // },
  // stepName: function (val) {
  // if (val === "Payment-3" && (['ach','wire'].includes(this.$store.state.payments?.newPaymentMethodType))) {
  //   setTimeout(() => {
  //     const findRoutingNumber = document.querySelector("#routing_number");
  //     findRoutingNumber.focus();
  //   }, 0);
  // }
  // if (
  //   val === "Payment-3" &&
  //   this.$props.data.payment.newPaymentMethodType === "check" &&
  //   this.firstTime
  // ) {
  //   setTimeout(() => {
  //     const findAddress = document.querySelector("#autocomplete");
  //     findAddress.focus();
  //   }, 0);
  // }
  // if (val === "Payment-3" && this.firstTime) {
  //   this.$store.commit("toggleDisabledButton", { bool: true, source: 'PaymentStepThree #2' });
  // }
  // },
  // },
  setup() {
    const store = useStore();
    const componentIdentifier = 'Payment-3';
    const toast = useToast();
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const hasLatestFactor = computed(
      () => store.state.factors?.latestFactor?.length > 0
    );
    const buttonCheck1 = computed(
      () =>
        (firstTime.value && !hasLatestFactor.value) ||
        store.state.payments?.edit?.check_ach ||
        store.state.payments?.edit?.factor
    );
    const buttonsToDisplay = computed(() => {
      if (buttonCheck1.value) return 'continue-save';

      // No firstTime changes in original flow, may need to add later
      return 'continue-save';
    });
    const isButtonDisabled = false;

    const onboardingPacketId = computed(() => store.state.onboardingPacket?.id);
    const companyType = computed(
      () => store.state.users.currentUser?.company?.company_type
    );
    const paymentMethod = ref(null);

    watch(
      () => store.state.payments?.payment_body,
      (newVal) => {
        paymentMethod.value = newVal;
      },
      { deep: true, immediate: true }
    );

    const isEmptyObj = (obj) => {
      if (!obj) return true;
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false;
        }
      }
      return JSON.stringify(obj) === JSON.stringify({});
    };
    const isPaymentMethodParamEmpty = (paymentMethod) => {
      if (!paymentMethod) return true;
      if (
        !('payment_method' in paymentMethod) ||
        isEmptyObj(paymentMethod?.payment_method)
      ) {
        return true;
      }
      return false;
    };

    const createPaymentMethod = async (paymentMethod, onboardingPacketId) => {
      if (isPaymentMethodParamEmpty(paymentMethod)) {
        /**
         * The payment_method parameter is required in order to continue with the next step.
         */
        toast?.open({
          message:
            'Something went wrong with your request. Please return to the payment method selection screen and try again',
          position: 'top-right',
          duration: 5000,
        });
        return false;
      }
      let paymentResponse = null;

      try {
        paymentResponse = await store.dispatch('payments/createPaymentMethod', {
          paymentMethod,
          onboardingPacketId,
        });
        await store.dispatch(
          'payments/getActivePaymentMethods',
          onboardingPacketId
        );
        if (
          [422].includes(paymentResponse?.status) &&
          paymentResponse?.data?.payment_method?.[0] ==
            'verification required for adding additional payment methods'
        ) {
          store.commit(
            'addFormDebugMessage',
            componentIdentifier +
              ': User attempted to create payment method but received `verification required for adding additional payment methods` error from server, redirecting to Payment-4 for verification'
          );
          await formRouter.moveToStepByIdentifier('Payment-4');
        } else if ([401, 403, 404, 422].includes(paymentResponse?.status)) {
          throw new Error('An error has ocurred');
        }
      } catch (error) {
        if (!paymentResponse) paymentResponse = error?.response;
        if (paymentResponse) {
          toast?.open({
            message: formatErrorResponse(paymentResponse),
            position: 'top-right',
            duration: 5000,
          });
        }
        // If there is an error trying to create the payment methods do not allow
        // the user to continue with the next step.
        return false;
      }
      return true;
    };

    // nextChecks: Checks to be reviewed when the user clicks the Continue button (but before any store.state.formRoutes.activeStep changes)
    const nextCheck1 = computed(
      () => store.state.payments.newPaymentMethodType !== 'check'
    );
    const nextCheck2 = computed(
      () => store.state.payments.newPaymentMethodType === 'check'
    );

    const handleNext = async () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (nextCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck1 is TRUE (Payment-3 entering bank account of check mailing address), creating payment_method, setting firstTime.Payment to false, and moving to Questions step'
        );
        if (store.state.payments.errors) {
          store.commit('updateField', { name: 'errors', value: true });
          return store.commit(
            'addFormDebugMessage',
            'ERROR | ' +
              componentIdentifier +
              ': nextCheck1 logic - errors present in form (see payments.errors), returning'
          );
        } else {
          store.commit('updateField', { name: 'errors', value: false });
          if (companyType.value !== 'carrier') {
            paymentMethod.value.payment_method['onboarding_packet_id'] =
              onboardingPacketId.value;
          }

          if (
            store.state.carriers?.carrierData?.payment_method ||
            store.state.payments?.verification_id > 0
          ) {
            if (paymentMethod.value !== undefined) {
              paymentMethod.value.payment_method['verification_id'] =
                store.state.payments.verification_id;
            }
          }

          const paymentResponse = await createPaymentMethod(
            paymentMethod.value,
            onboardingPacketId.value
          );
          if (!paymentResponse)
            return store.commit(
              'addFormDebugMessage',
              'ERROR | ' +
                componentIdentifier +
                ": nextCheck1 logic - no paymentResponse received ('createPaymentMethod' failed)"
            );
          store.commit('firstTime/updateStepFirstTime', {
            step: 'Payment',
            value: false,
          });
          return formRouter.moveToStepByIdentifier('Questions');
        }
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck1 is FALSE (POSSIBLE ERROR AT THIS POINT - TROUBLESHOOTING NEEDED)'
        );
      }

      if (nextCheck2.value) {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck2 is TRUE (Payment-3 entering check mailing address), creating payment_method, setting firstTime.Payment to false, and moving to Questions step'
        );
        store.commit('updateField', { name: 'errors', value: false });
        if (companyType.value !== 'carrier') {
          paymentMethod.value.payment_method['onboarding_packet_id'] =
            onboardingPacketId.value;
        }

        if (
          store.state.carriers?.carrierData?.payment_method ||
          store.state.payments?.verification_id > 0
        ) {
          if (paymentMethod.value !== undefined) {
            paymentMethod.value.payment_method['verification_id'] =
              store.state.payments.verification_id;
          }
        }

        const paymentResponse = await createPaymentMethod(
          paymentMethod.value,
          onboardingPacketId.value
        );
        if (!paymentResponse)
          return store.commit(
            'addFormDebugMessage',
            'ERROR | ' +
              componentIdentifier +
              ": nextCheck2 logic - no paymentResponse received ('createPaymentMethod' failed)"
          );
        store.commit('firstTime/updateStepFirstTime', {
          step: 'Payment',
          value: false,
        });
        return formRouter.moveToStepByIdentifier('Questions');
      } else {
        store.commit(
          'addFormDebugMessage',
          'NEXT CHECK | ' +
            componentIdentifier +
            ': nextCheck2 is FALSE (Payment-3 not entering check mailing address)'
        );
      }
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      paymentMethod,
    };
  },
  data() {
    return {
      sample_banks: stepInformation.payment.sample_banks,
      phone_number: '',
    };
  },
  computed: {
    newPaymentMethodType() {
      return this.$store.state.payments.newPaymentMethodType;
    },
  },
};
</script>

<style></style>
